import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { SignupSection } from '.';
import { IUserSignUpResponse } from '@gik/api/users/auth';
import SignupCalloutGeneric from '@gik/auth/components/Signup/SignupCalloutGeneric';

const blockName = 'signup-modal-content';

export interface ISignupModalContentProps {
  calloutBlock?: React.ReactNode;
  buttonsPortal?: () => HTMLElement;
  onSuccess?: (doneResponse: IUserSignUpResponse) => void | Promise<void>;
  onLogin?: () => void;
}

export default function SignupModalContent({
  buttonsPortal,
  onSuccess,
  onLogin,
  calloutBlock = <SignupCalloutGeneric />,
}: ISignupModalContentProps) {
  const bem = bemBlock(blockName);

  return (
    <section className={bem()}>
      {calloutBlock}
      <div className={bem('form-wrapper')}>
        <SignupSection buttonsPortal={buttonsPortal} onSuccess={onSuccess} onLogin={onLogin} />
      </div>
    </section>
  );
}
